import React from 'react';
import './App.css';

// Component
import Clock from './component/clock'
import Link from './component/link'
import Calendar from './component/calendar'

class App extends React.Component{
  render(){
    return(
      <div>
        <Calendar />
        <Clock />
        <Link />
      </div>
    )
  }
}



export default App;


// WEBPACK FOOTER //
// ./src/App.js